import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./calendar.scss"
interface PropsData {
  value: Date | null;
  setValue: (value: Date | null) => void;
  className?:string;
}
const Calender = ({ value, setValue,className }: PropsData) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="d-flex w-100 common-year-picker">
      <ReactDatePicker
        selected={value}
        onChange={(date) => setValue(date)}
        showYearPicker
        openToDate={new Date()}
        placeholderText="Select Year"
        className={`form-control w-100 ${className}`}
        dateFormat="yyyy"
        wrapperClassName="w-100"

        // ✅ FIXED
        minDate={new Date(currentYear, 0, 1)}
        maxDate={new Date(currentYear + 20, 11, 31)}

        renderCustomHeader={({
          decreaseYear,
          increaseYear,
          prevYearButtonDisabled,
          nextYearButtonDisabled
        }) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "5px 10px"
            }}
          >
            <button
              type="button"
              onClick={decreaseYear}
              disabled={prevYearButtonDisabled}
              className="btn btn-light btn-sm"
            >
              ◀
            </button>

            <span style={{ fontWeight: "bold" }}>Select Year</span>

            <button
              type="button"
              onClick={increaseYear}
              disabled={nextYearButtonDisabled}
              className="btn btn-light btn-sm"
            >
              ▶
            </button>
          </div>
        )}
      />
    </div>
  );
};


export default Calender;
